import { render, staticRenderFns } from "./ReaderAppUser.vue?vue&type=template&id=1ed65df2"
import script from "./ReaderAppUser.vue?vue&type=script&lang=js"
export * from "./ReaderAppUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports